import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Href } from "../../../../Constants/Constants";
import { DropdownCommonProp } from "../../../../Types/UiKitsType";

const DropdownCommon: React.FC<DropdownCommonProp> = ({ item, toggleClass }) => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup className={item.divClass}>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction={item.position ? item.position : "down"}>
        <DropdownToggle caret className={toggleClass} color={item.class}>
          {item.text}
        </DropdownToggle>
        <DropdownMenu className={item.bodyClass}>
          {item.menulist &&
            item.menulist.map((item, index) => (
              <DropdownItem href={Href} key={index}>
                {item}
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default DropdownCommon;
